export default class Dialog {
    constructor() {
        //
    }

    confirm(title, content, callback) {
        this.showModal(title, content, callback);
        $("#dialog-confirm-buttons").removeClass("d-none");
    }

    alert(title, content) {
        this.showModal(title, content);
        $("#dialog-alert-buttons").removeClass("d-none");
    }

    showModal(title, content, callback) {
        $("#dialog-title").text(title);
        $("#dialog-content").text(content);

        // hide all buttons
        $(".dialog-buttons").addClass("d-none");

        // ok button
        if (typeof callback == "function") {
            $(".dialog-ok-button").off("click").on("click", function() {
                callback();
            });
        }

        // show modal
        $("#dialog").modal();
    }
}
